import { Box, Button, Card, Select, TextField, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

// Styles partagés par VoyageurInsert et VoyageurUpdate, qui en portaient chacun
// une copie identique (69 lignes dupliquées de part et d'autre).
//
// Correction faite au passage, une fois pour les deux : l'anneau de focus était
// resté au bleu MUI par défaut alors que tout le reste de l'écran est vert.
const ANNEAU_FOCUS = '0 0 0 2px rgba(46, 125, 50, 0.2)';

export const StyledCard = styled(Card)(({ theme }) => ({
  borderRadius: 16,
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.08)',
  marginBottom: theme.spacing(3),
  border: '1px solid',
  borderColor: theme.palette.divider,
  transition: 'all 0.3s ease',
  '&:hover': {
    boxShadow: '0 12px 48px rgba(0, 0, 0, 0.12)',
  },
}));

export const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: 12,
    backgroundColor: theme.palette.background.paper,
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
    '&.Mui-focused': {
      backgroundColor: theme.palette.background.paper,
      boxShadow: ANNEAU_FOCUS,
    },
  },
}));

export const StyledSelect = styled(Select<string>)(({ theme }) => ({
  borderRadius: 12,
  backgroundColor: theme.palette.background.paper,
  transition: 'all 0.3s ease',
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
  '&.Mui-focused': {
    backgroundColor: theme.palette.background.paper,
    boxShadow: ANNEAU_FOCUS,
  },
})) as unknown as typeof Select<string>;

export const UploadButton = styled(Button)(({ theme }) => ({
  borderRadius: 12,
  padding: theme.spacing(2),
  borderStyle: 'dashed',
  borderWidth: 2,
  backgroundColor: theme.palette.background.paper,
  transition: 'all 0.3s ease',
  '&:hover': {
    borderStyle: 'solid',
    backgroundColor: theme.palette.action.hover,
  },
})) as typeof Button;

export const PreviewContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  borderRadius: 12,
  overflow: 'hidden',
  boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
  position: 'relative',
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  marginBottom: theme.spacing(2),
  color: theme.palette.text.primary,
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));
